import { Box, type BoxProps } from '@mantine/core'
import { clsx } from 'clsx'
import Link from 'next/link'
import React, { type PropsWithChildren } from 'react'

import { Logo } from '../../../src/components/Logo/Logo'
import { useMenus } from '../../hooks/useMenus'
import { NavbarItem } from './NavbarItem'
import classes from './styles.module.css'
import { UserMenu } from './UserMenu'

export function NavbarDesktop({ className }: PropsWithChildren<BoxProps>) {
  const { menus } = useMenus()
  const navbarClasses = clsx(classes.navbarWrapper, className)

  return (
    <Box className={navbarClasses}>
      <Link href='/' className={classes.navbarLogo}>
        <Logo />
      </Link>

      <Box className={classes.navbarGroup}>
        {menus.map((menu) => (
          <NavbarItem key={`navbar-item-${menu.path}`} item={menu} />
        ))}
      </Box>

      <Box className={classes.navbarGroup}>
        <UserMenu />
      </Box>
    </Box>
  )
}
